export default "__VITE_ASSET__f8eb19d1__"